import { Text } from '@dixa/lib-shared-habla';

import { Category } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';

import styles from './CategoryTags.module.scss';

type CategoryTagsProps = {
  articleTags: string[];
  categoryTitle: Category['title'];
};

export function CategoryTags({
  categoryTitle,
  articleTags,
}: CategoryTagsProps): JSX.Element {
  const categoryAndTags = articleTags.length
    ? `${categoryTitle} · ${articleTags.join(', ')}`
    : categoryTitle;

  return (
    <Text.Heading
      className={styles.heading}
      color="tertiary"
      variant="heading-4"
    >
      {categoryAndTags}
    </Text.Heading>
  );
}
